import React from 'react';

import './chessground.css';

import { withRouter } from 'react-router-dom';

import { Typography, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FlipIcon from '@material-ui/icons/Cached';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Dialog, DialogContent } from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import MenuIcon from '@material-ui/icons/Menu';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { LinearHistory } from './History';
import Board from './chessground';
import AnalysisController from './AnalysisController';
import EngineSelector from './EngineSelector';
import { START_FEN, normalizeFen, createGame, cloneGame, getEvalText, parsePgn, engineStatusText, makeEngineLines, rootFen, readerLayout } from './game.mjs';
import { readEnginePreference, readEngineSelection } from '../../enginePreference';
import settings from '../../settings';

// our blue color
// backgroundColor: '#006fe6'

const infoLandscapeWidth = 200; // TODO: have this in remote config?

const styles = (theme) => ({
  container: {
    // marginTop: 60,  // TODO: remember that this is just for injecting the page as iframe into browser extension
    backgroundColor: 'rgb(237, 235, 233)',
  },
  containerLandscape: {
  },
  containerPortrait: {
    // maxWidth: 600, // TODO: set this to 1600 maybe?
    // margin: '0 auto',
    // justifyContent: 'space-evenly',
  },
  boardWrapper: {
    flex: 1,
  },
  boardWrapperLandscape: {
    display: 'flex',
    justifyContent: 'center',
  },
  boardWrapperPortrait: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  board: {
    // flex: 1,
  },
  boardLandscape: {
  },
  boardPortrait: {
    alignSelf: 'center',
  },
  info: {
  },
  infoLandscape: {
    flex: 1,
    minWidth: infoLandscapeWidth,
    maxWidth: infoLandscapeWidth,
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  infoPortrait: {
    flex: 1,
  },
  boardButtons: {
    display: 'flex',
  },
  engineContainerLandscape: {
    flex: 1,
  },
  fenInputWrapper: {
    display: 'flex',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  pgnInputWrapper: {
    display: 'flex',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    alignItems: 'flex-start',
  },
  importText: {
    flex: 1,
    backgroundColor: '#f8f9fb',
    minWidth: 0,
    height: 36,
    '& input': {
      fontSize: 12,
    }
  },
  importTextarea: {
    flex: 1,
    backgroundColor: '#f8f9fb',
    minWidth: 0,
    '& textarea': {
      fontSize: 12,
    }
  },
  importButton: {
    fontSize: 12,
    textTransform: 'none',
    width: 70,
    marginLeft: theme.spacing(1),
    height: 36,
  },

  engineWrapper: {
    backgroundColor: 'white',
  },
  engineHeader: {
    display: 'flex',
    minHeight: 38,
    justifyContent: 'space-between',
    background: 'linear-gradient(180deg, #f7f8fa 0%, #edeff2 100%)',
    boxShadow: 'inset 0 -1px 0 rgba(28, 40, 60, 0.08)',
  },
  engineHeaderText: {
    fontSize: 12,
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  engineHeaderEval: {
    alignSelf: 'center',
    paddingLeft: 10,
    fontSize: 21,
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
    width: 75,
    flexShrink: 0,
    textAlign: 'center',
  },
  engineHeaderInfo: {
    fontSize: 12,
  },
  engineToggleLabel: {
    fontSize: 12,
  },
  engineLineWrapper: {
    width: '100%',
    fontSize: 13,
    display: 'block',
    height: 26,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid #e2e5e9',
    '&:hover': { backgroundColor: '#f4f7fb' },
    maxWidth: '100%',
  },
  engineLineScore: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.35),
    width: 34,
    display: 'inline-block',
  },
  engineMove: {
    textTransform: 'none',
    minWidth: 'auto',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
  historyWrapper: {
    backgroundColor: 'white',
  },
  history: {
    padding: theme.spacing(1),
  },

  depthRow: {
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
    height: 18,
    verticalAlign: 'top',
  },
  depthText: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 11,
  },
  depthButton: {
    flex: '0 0 20px',
    width: 20,
    height: 18,
    marginLeft: 2,
    padding: 0,
    borderRadius: 3,
    fontSize: 17,
    lineHeight: 1,
    '&[aria-pressed="true"]': {
      backgroundColor: 'rgba(0, 123, 255, 0.1)',
    },
  },
  engineToggle: {
    marginLeft: 0,
    marginRight: 4,
  },
});

const { 
  ENGINE_DEFAULT_ON, ENGINE_MULTIPV, MAX_ENGINE_LINE, 
  ARROWS_CENTIPAWNLOSS_THRESH 
} = settings.engine;

class ReaderAnalysisBoard extends AnalysisController {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(props.location.search);
    const rawFen = urlParams.get('fen') ?? props.match?.params.fen;
    this.initFen = normalizeFen(rawFen ?? START_FEN);
    this.rememberEnginePreference = settings.engine.REMEMBER_ENGINE_ENABLED_READER_ANALYSIS;
    this.rememberEngineSelection = settings.engine.REMEMBER_ENGINE_SELECTION_READER_ANALYSIS;
    const selectedEngine = readEngineSelection(
      settings.engine.ENGINE_DEFAULT_TYPE, this.rememberEngineSelection
    );
    this.state = {
      fen: this.initFen,
      orientation: urlParams.get('color') === 'black' ? 'black' : 'white',

      lastMoveId: -1,

      fenInput: null,
      pgnInput: null,
      engineStatus: 'off',
      engineError: '',
      positionError: '',

      engineOn: readEnginePreference(ENGINE_DEFAULT_ON, this.rememberEnginePreference),
      engineUnlimited: false,
      selectedEngine,
      engineName: selectedEngine === 'nnue'
        ? settings.engine.ENGINE_NAME : settings.engine.ENGINE_JS_FALLBACK_NAME,
      engineMenuAnchorEl: null,

      // pawn promotion
      pendingMove: null,
      promotionDialog: false,

      // engine
      bestMove: null,
      evals: [],

      // menu
      menuAnchorEl: null,

      // window size
      window: {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth,
      },
    };
    this.game = createGame(this.state.fen);
    // using: https://stackoverflow.com/a/42141641/948918
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }


  openMenu = (e) => {
    this.setState({
      menuAnchorEl: e.currentTarget,
    });
  }

  closeMenu = () => {
    this.setState({
      menuAnchorEl: null,
    });
  }

  componentDidMount() {
    super.componentDidMount();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ window: {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    } });
  }

  // game 
  onMove = (from, to) => {
    const clone = cloneGame(this.game, this.state.lastMoveId);
    const moves = clone.moves({ verbose: true })
    for (const move of moves) {
      if (move.flags.indexOf("p") !== -1 && move.from === from && move.to === to) {
        this.setState({
          pendingMove: [from, to],
          promotionDialog: true,
        });
        return;
      }
    }

    // see if the move is legal
    const move = clone.move({
      from,
      to,
      promotion: "q",
    });
    if (move === null) {
      this.setState({
        fen: clone.fen(),
      });
    } else {
      this.game = clone;
      this.setState({
        fen: this.game.fen(),
        lastMoveId: this.state.lastMoveId + 1,
      }, () => {
        this.getScore();
        const e = document.getElementById('history-container');
        if (e) e.scrollTop = e.scrollHeight;
      })
    }
  };

  makeEngineMoves = (moves) => {
    const clone = cloneGame(this.game, this.state.lastMoveId);
    for (const { from, to, promotion } of moves) {
      if (!clone.move({ from, to, promotion })) return;
    }
    this.game = clone;
    const history = this.game?.history();
    this.setState({
      fen: this.game.fen(),
      lastMoveId: history.length - 1,
    }, () => {
      this.getScore();
      const e = document.getElementById('history-container');
      if (e) {
        if (e) e.scrollTop = e.scrollHeight;
      }
    });
  }

  promotion = e => {
    const { pendingMove } = this.state;
    if (!pendingMove) return;
    const from = pendingMove[0];
    const to = pendingMove[1];
    const clone = cloneGame(this.game, this.state.lastMoveId);
    const move = clone.move({ from, to, promotion: e });
    if (move !== null) {
      this.game = clone;
      this.setState({
        fen: clone.fen(),
        lastMoveId: this.state.lastMoveId + 1,
        promotionDialog: false,
        pendingMove: null,
      }, () => {
        this.getScore();
        const e = document.getElementById('history-container');
        if (e) e.scrollTop = e.scrollHeight;
      })
    }
  }

  moveToFront() {
    const clone = cloneGame(this.game, -1);
    this.setState({
      lastMoveId: -1,
      fen: clone.fen(),
    }, () => {
      this.getScore();
      const e = document.getElementById('history-container');
      if (e) e.scrollTop = e.scrollHeight - e.clientHeight;
    });
  }

  undo() {
    const newLastMoveId = Math.max(-1, this.state.lastMoveId - 1);
    const clone = cloneGame(this.game, newLastMoveId);
    this.setState({
      lastMoveId: newLastMoveId,
      fen: clone.fen(),
    }, () => {
      this.getScore();
    });
  }

  redo() {
    const history = this.game?.history();
    const newLastMoveId = Math.min(this.state.lastMoveId + 1, history.length - 1);
    const clone = cloneGame(this.game, newLastMoveId);
    this.setState({
      lastMoveId: newLastMoveId,
      fen: clone.fen(),
    }, () => {
      this.getScore();
    })
  }

  moveToEnd() {
    const history = this.game?.history();
    const clone = cloneGame(this.game, history.length - 1);
    this.setState({
      lastMoveId: history.length - 1,
      fen: clone.fen(),
    }, () => {
      this.getScore();
      const e = document.getElementById('history-container');
      if (e) e.scrollTop = e.scrollHeight;
    });
  }

  handleBookMoveClick = (uci) => {
    const from = uci.substr(0, 2);
    const to = uci.substr(2, 2);
    this.onMove(from, to);
  }

  handleHistoryMoveClick = (newLastMoveId) => {
    const clone = cloneGame(this.game, newLastMoveId);

    this.setState({
      lastMoveId: newLastMoveId,
      fen: clone.fen(),
    }, () => {
      this.getScore();
    });
  }

  setFen = (input) => {
    const fen = normalizeFen(input);
    this.engine?.pause();
    this.failedAnalysis = null;
    this.game = createGame(fen);
    this.setState({
      fen,
      fenInput: null,
      pgnInput: null,
      positionError: '',
      engineError: '',
      engineUnlimited: false,
      promotionDialog: false,
      pendingMove: null,
      lastMoveId: -1,
      bestMove: null,
      evals: [],
    }, () => this.getScore());
  }

  setPgn = () => {
    const game = parsePgn(this.state.pgnInput);
    if (!game) return;
    this.engine?.pause();
    this.failedAnalysis = null;
    this.game = game;
    this.setState({
      engineError: '',
      engineUnlimited: false,
      bestMove: null,
      evals: [],
      pgnInput: null,
      fenInput: null,
      positionError: '',
      promotionDialog: false,
      pendingMove: null,
      fen: game.fen(),
      lastMoveId: game.history().length - 1,
    }, () => this.getScore());
  }

  calcMovable = () => {
    const dests = new Map();
    const clone = cloneGame(this.game, this.state.lastMoveId);
    clone.SQUARES.forEach(s => {
      const ms = clone.moves({ square: s, verbose: true });
      if (ms.length) {
        dests.set(s, ms.map(m => m.to));
      }
    });
    return {
      free: false,
      dests,
      color: clone.turn() === "w" ? "white" : "black",
    };
  }

  openLichessAnalysis = () => {
    const { history } = this.props;
    const url = `${settings.routes.LICHESS_BOARD_ANALYSIS}/${this.state.fen.split(' ').join('_')}`;
    history.push(url);
  }

  renderBoardButtons = ({ classes, lastMoveId, controlButtonStyles, history, orientation, menuAnchorEl }) => {
    return (
      <div className={classes.boardButtons}>
        <IconButton
          aria-label="First move"
                  variant="outlined"
          onClick={() => { this.moveToFront() }}
          disabled={lastMoveId === -1}
        ><FirstPageIcon style={controlButtonStyles} /></IconButton>
        <IconButton
          aria-label="Previous move"
                  variant="outlined"
          onClick={() => { this.undo() }}
          disabled={lastMoveId === -1}
        ><NavigateBeforeIcon style={controlButtonStyles} /></IconButton>
        <IconButton
          aria-label="Next move"
                  variant="outlined"
          onClick={() => { this.redo() }}
          disabled={!history || lastMoveId === history.length - 1}
        ><NavigateNextIcon style={controlButtonStyles} /></IconButton>
        <IconButton
          aria-label="Last move"
                  variant="outlined"
          onClick={() => { this.moveToEnd() }}
          disabled={!history || lastMoveId === history.length - 1}
        ><LastPageIcon style={controlButtonStyles} /></IconButton>
        <div style={{ flex: 1}} />
        <Tooltip title="Flip board">
          <IconButton
            aria-label="Flip board"
            onClick={this.handleOrientationChange}
          ><FlipIcon /></IconButton>
        </Tooltip>
        <Tooltip title="Menu">
          <IconButton
            aria-label="Board menu"
            onClick={this.openMenu}
          ><MenuIcon /></IconButton>
        </Tooltip>
        <Menu
          anchorEl={menuAnchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          keepMounted
          open={Boolean(menuAnchorEl)}
          onClose={this.closeMenu}
        >
          {/*<MenuItem onClick={this.openLichessAnalysis}>Open in Lichess Analysis</MenuItem>*/}
          <MenuItem onClick={() => {this.handleSetStartingPosition(START_FEN); this.closeMenu()}}>Restore Starting Position</MenuItem>
        </Menu>
      </div>
    );

  }

  handleOrientationChange = () => {
    const { orientation } = this.state;
    this.setState({ 
      orientation: orientation === 'white' ? 'black' : 'white', 
    }, () => {
      // TODO: send message to iframe parent here
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify(
            { 
              name: "povChanged",
              payload: { 
                pov: this.state.orientation,
              }, 
            }
          )
        );
      }
    });
  }

  handleSetStartingPosition = () => {
    this.setFen(START_FEN);
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify(
          { 
            name: "startingPositionRestored",
            payload: {},
          }
        )
      );
    }
  }

  render() {
    const { classes } = this.props;

    const { fen, orientation, lastMoveId } = this.state;
    const { engineOn } = this.state;
    const { promotionDialog } = this.state;

    const { menuAnchorEl } = this.state;

    const history = this.game?.history({ verbose: true });
    const lastMove = history && history.length 
      ? history[lastMoveId]
      : null;

    const clone = cloneGame(this.game, lastMoveId);
    const isGameOver = this.state.engineStatus === 'no-moves';

    const { evals } = this.state;
    const arrows = engineOn ? evals.filter(e => e?.pv?.length &&
      (e.mate || !evals[0] || Math.abs(evals[0].score - e.score) < ARROWS_CENTIPAWNLOSS_THRESH))
      .map(e => ({ ...e.pv[0], color: e.index === 0 ? 'paleBlue' : 'paleGrey' })) : [];
    const engineLines = makeEngineLines(evals, fen, ENGINE_MULTIPV, MAX_ENGINE_LINE);

    const controlButtonStyles = { fontSize: 32 };

    const { window } = this.state;
    const { boardSize, isLandscape } = readerLayout(window.width, window.height, engineOn);

    const renderBoardButtons = () => this.renderBoardButtons({ classes, lastMoveId, controlButtonStyles, history, orientation, menuAnchorEl });

    const canExtend =
      engineOn &&
      Boolean(evals[0]) &&
      !['loading', 'no-moves', 'error'].includes(this.state.engineStatus);

    const depthAction = this.state.engineUnlimited
      ? `Return to depth ${settings.engine.ENGINE_DEPTH}`
      : 'Analyze further (no depth limit)';

    const engineStatus = engineStatusText(this.state, clone);

    const depthText = canExtend && evals[0]
      ? `Depth ${evals[0].depth}`
      : engineStatus;

    return (
      <>
        <div className={[classes.container, isLandscape ? classes.containerLandscape : classes.containerPortrait].join(' ')}>
          <div className={[classes.boardWrapper, isLandscape ? classes.boardWrapperLandscape : classes.boardWrapperPortrait].join(' ')}>
            <div className={[classes.board, isLandscape ? classes.boardLandscape : classes.boardPortrait].join(' ')}>
              <Board
                fen={fen}
                onMove={this.onMove}
                orientation={orientation}
                lastMove={lastMove ? [lastMove.from, lastMove.to] : null}
                movable={this.calcMovable()}
                arrows={engineOn ? arrows : []}
                arrowsEnabled={true}
                arrowsVisible={true}
                check={clone.in_check()}
                width={boardSize}
                height={boardSize}
              />
            </div>
            <div className={[classes.info, isLandscape ? classes.infoLandscape : classes.infoPortrait].join(' ')}>
              {!isLandscape && renderBoardButtons()}
              <div className={[classes.engineContainer, isLandscape ? classes.engineContainerLandscape : classes.engineContainerPortrait].join(' ')}>
                <div className={classes.engineWrapper}>
                  <div className={classes.engineHeader}>
                    <div className={classes.engineHeaderEval}>
                      { isGameOver && (
                        <span>-</span>
                      )}
                      { !isGameOver && engineOn && evals[0] && (
                        <span>{getEvalText({ score: evals[0].score, mate: evals[0].mate })}</span>
                      )}
                    </div>
                    <Typography component="div" className={classes.engineHeaderText}>
                      <EngineSelector
                        name={this.state.engineName}
                        selectedEngine={this.state.selectedEngine}
                        anchorEl={this.state.engineMenuAnchorEl}
                        onOpen={this.openEngineMenu}
                        onClose={this.closeEngineMenu}
                        onSelect={this.selectEngine}
                      />
                      <span className={classes.depthRow}>
                        <span
                          className={classes.depthText}
                          role="status"
                          title={this.getEngineStatusTitle(engineStatus)}
                        >
                          {depthText}
                        </span>

                        {canExtend && (
                          <Tooltip title={depthAction}>
                            <IconButton
                              className={classes.depthButton}
                              color="primary"
                              size="small"
                              aria-label={depthAction}
                              aria-pressed={this.state.engineUnlimited}
                              onClick={this.toggleAnalysisDepth}
                            >
                              <span aria-hidden="true">
                                {this.state.engineUnlimited ? '∞' : '+'}
                              </span>
                            </IconButton>
                          </Tooltip>
                        )}
                      </span>
                    </Typography>
                    <FormControlLabel
                      classes={{
                        label: classes.engineToggleLabel,
                        root: classes.engineToggle,
                      }}
                      control={
                        <Switch
                          size="small"
                          color="secondary"
                          inputProps={{ 'aria-label': 'Toggle analysis engine' }}
                          name="engine"
                          checked={engineOn}
                          onChange={this.toggleEngine}
                        />
                      }
                    />
                  </div>
                  { engineOn && engineLines.length > 0 && (
                    <div className={classes.engineInfo}>
                      { engineLines.map((engineLine, i) => (
                        <div className={classes.engineLineWrapper} key={`engine-line-${i}`}>
                          { engineLine.length > 0 && (
                            <>
                              <strong className={classes.engineLineScore}>
                                { getEvalText({ score: evals[i].score, mate: evals[i].mate })}
                              </strong>
                              { engineLine.map((san, j) => {
                            const offset = Number(fen.split(' ')[5]) - 1;

                                const startWithBlack = clone.turn() === 'b';
                                const isNumbered = (j % 2 === 0 && !startWithBlack) || (startWithBlack && (j === 0 || j % 2 === 1));
                                const fullMoveNumber = offset + (startWithBlack ? (j === 0 ? 0 : (j+1) / 2) : (j / 2));
                                return (
                                  <Button 
                                    key={`san-${j}`}
                                    size="small"
                                    variant="text"
                                    className={classes.engineMove}
                                    onClick={() => { this.makeEngineMoves(evals[i].pv.slice(0, j+1)) }}
                                  >
                                    {isNumbered && `${fullMoveNumber+1}${startWithBlack && j === 0 ? '...' : '.' }`}
                                    {san}
                                  </Button>
                                )
                              })}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                { history && history.length > 0 && (
                  <div className={classes.historyWrapper}>
                    <div className={classes.history} id="history-container">
                      <LinearHistory
                        startMoveNumber={Number(rootFen(this.game).split(' ')[5])}
                        lastMoveId={lastMoveId}
                        history={history}
                        onMoveClick={this.handleHistoryMoveClick}
                      />
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>
          {isLandscape && renderBoardButtons()}
          <Dialog aria-label="Choose a promotion piece" open={promotionDialog} onClose={() => { this.setState({ promotionDialog: false, pendingMove: null })}}>
            <DialogContent>
              <Button onClick={() => { this.promotion("q")}}>Queen</Button>
              <Button onClick={() => { this.promotion("r")}}>Rook</Button>
              <Button onClick={() => { this.promotion("b")}}>Bishop</Button>
              <Button onClick={() => { this.promotion("n")}}>Knight</Button>
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(withRouter(ReaderAnalysisBoard));
